import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import SessionFilters from '../session-filters/SessionFilters';
import SessionList from '../session-list/SessionList';

import scss from './SessionHistoryContent.module.scss';

function SessionHistoryContent({ isAdmin, onSelectSession, onChangePage, showTitle = true, className }) {
  const { t } = useTranslation('story');

  return (
    <div className={clsx(scss.content, className)}>
      {showTitle ? <h3 className={scss.title}>{t('sessionHistory')}</h3> : null}

      <SessionFilters isAdmin={isAdmin} />

      <SessionList onSelectSession={onSelectSession} onChangePage={onChangePage} />
    </div>
  );
}

export default SessionHistoryContent;
